package team.platforma.multiplatform_material_extension.ui.full_name

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.TextField
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.intl.Locale
import androidx.compose.ui.text.intl.LocaleList
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import materialextension.multiplatform_material_extension.generated.resources.Res
import materialextension.multiplatform_material_extension.generated.resources.ic24_mel_exit_circle
import materialextension.multiplatform_material_extension.generated.resources.mel_ic_clear
import team.platforma.multiplatform_material_extension.ui.core.InputField
import team.platforma.multiplatform_material_extension.ui.core.InputFieldProperties
import team.platforma.multiplatform_material_extension.ui.core.InputFieldStateListener
import team.platforma.multiplatform_material_extension.ui.core.StyledTextField
import team.platforma.multiplatform_material_extension.ui.core.field_utils.HelperMessage
import team.platforma.multiplatform_material_extension.ui.core.field_utils.endIcon
import team.platforma.multiplatform_material_extension.ui.core.global_style.area.supportArea
import team.platforma.multiplatform_material_extension.ui.core.global_style.setFiledTextFieldDefaults
import team.platforma.multiplatform_material_extension.ui.core.global_style.setOutlinedTextFieldDefaults
import team.platforma.multiplatform_material_extension.ui.core.global_style.shape.setFilledTextFieldDefaultShape
import team.platforma.multiplatform_material_extension.ui.core.global_style.shape.setOutlineTextFieldDefaultShape
import team.platforma.multiplatform_material_extension.ui.core.rememberInputFieldState
import team.platforma.multiplatform_material_extension.util.forms.FormProperties
import team.platforma.multiplatform_material_extension.util.forms.keyListener
import team.platforma.multiplatform_material_extension.util.forms.rememberForms
@Deprecated("")
object FullNameField : InputField {
    @Composable
    fun create(
        modifier: Modifier? = null,
        message: FullNameMessage? = null,
        value: String?,
        formProperties: FormProperties? = null,
        required: Boolean = true,
        onValueChange: (String) -> Unit,
        type: Type
    ): StyledTextField {

        val form by rememberForms()

        val mForm = formProperties ?: FormProperties(form, key = "")

        LaunchedEffect(mForm.key) {
            mForm.form.initValue(mForm.key, value ?: "")
            mForm.form.changeValue(mForm.key, value ?: "")
        }

        return builder(
            FullNameFieldImpl(
                areaModifier = modifier,
                value = value,
                form = mForm,
                required = required,
                onValueChange = {
                    onValueChange(it)
                },
                type = type,
                mMessage = message
            )
        )
    }

    override fun builder(textFieldImpl: StyledTextField): StyledTextField = textFieldImpl
}

@Composable
private fun FullNameFieldImpl(
    areaModifier: Modifier?,
    mMessage: FullNameMessage?,
    value: String?,
    form: FormProperties,
    required: Boolean,
    onValueChange: (String) -> Unit,
    type: Type
): StyledTextField {

    val inputFieldState = rememberInputFieldState()

    val focusRequester = remember { FocusRequester() }
    val index = remember { form.form.registerFocus(focusRequester) }

    var inputString by remember { mutableStateOf(value ?: "") }


    var error by remember { mutableStateOf(false) }

    var showSupportingText by remember { mutableStateOf(false) }

    val keyboardOptions = KeyboardOptions.Default.copy(
        capitalization = KeyboardCapitalization.Words,
        keyboardType = KeyboardType.Text,
        hintLocales = LocaleList(Locale("ru"))
    )


//    val mTextInputMessage = textInputMessage ?: TextInputMessage()

    var message by remember { mutableStateOf("") }

    var showEndIcon by remember { mutableStateOf(false) }

//    val focusRequester = remember { FocusRequester() }

    LaunchedEffect(inputString) {
        showEndIcon = inputString.isNotEmpty()
    }

    LaunchedEffect(Unit) {

        var valid = false
        validateUserInput(
            type = type,
            inputString = inputString,
            mMessage = mMessage,
            error = {},
            message = {
                message = it
            },
            showSupportingText = {
                showSupportingText = it
            },
            validate = {
                valid = it
            }
        )

        if (required) {
            if (inputString.isNotEmpty()) {
                form.form.setValidateState(form.key, valid)

            } else {
                form.form.setValidateState(form.key, false)
                showSupportingText = true
                message = mMessage?.required ?: "Обязательное поле"
            }
        } else {
            if (inputString.isNotEmpty()) {
                form.form.setValidateState(form.key, valid)
            } else {
                form.form.setValidateState(form.key, true)

            }
        }
    }

    val coroutineScope = rememberCoroutineScope()

    DisposableEffect(inputFieldState) {

        val listener = object : InputFieldStateListener {


            override fun onEndIconClick() {
                coroutineScope.launch {
                    while (inputString.isNotEmpty()) {
                        inputString = inputString.dropLast(1)
                        delay(15)
                    }

                    if (required) {
                        showSupportingText = true
                        error = true
                        message = mMessage?.required ?: "Обязательное поле"
                    } else {
                        showSupportingText = false
                        error = false
                    }
                    if (required) {
                        form.form.setValidateState(form.key, false)
                    } else {
                        form.form.setValidateState(form.key, true)
                    }
                    form.form.changeValue(form.key, "")
                    onValueChange("")
                }
            }

            override fun onValueChange(string: String) {

                val formattedText = string.split("-").joinToString("-") { part ->
                    part.split("'", "`").joinToString("'") { subPart ->
                        subPart.lowercase().replaceFirstChar { it.uppercase() }
                    }
                }

                inputString = formattedText.trim()

                onValueChange(inputString)

                form.form.changeValue(form.key, inputString)

                var valid = false

                validateUserInput(
                    type = type,
                    inputString = inputString,
                    mMessage = mMessage,
                    error = {
                        error = it
                    },
                    showSupportingText = {
                        showSupportingText = it
                    },
                    message = {
                        message = it
                    },
                    validate = {
                        valid = it
                    }
                )

                if (required) {
                    if (inputString.isNotEmpty()) {
                        form.form.setValidateState(form.key, valid)

                    } else {
                        form.form.setValidateState(form.key, false)
                        showSupportingText = true
                        error = true
                        message = mMessage?.required ?: "Обязательное поле"
                    }
                } else {
                    if (inputString.isNotEmpty()) {
                        form.form.setValidateState(form.key, valid)
                    } else {
                        form.form.setValidateState(form.key, true)
                        showSupportingText = false

                    }
                }
            }
        }

        inputFieldState.addListener(listener)

        onDispose {
            inputFieldState.removeListener(listener)
        }
    }


    val style = object : StyledTextField {
        @Composable
        override fun Outline(properties: InputFieldProperties?) {
            val mProperties = properties ?: InputFieldProperties()

            Column(
                modifier = (areaModifier ?: Modifier).width(IntrinsicSize.Min),
            ) {
                OutlinedTextField(
                    value = inputString,
                    onValueChange = { change ->
                        inputFieldState.changeValue(change)
                    },
                    label = mProperties.label,
                    modifier = (mProperties.modifier ?: Modifier)
                        .keyListener(Key.Tab) {
                            form.form.moveToNextFocus(index)
                        }.focusRequester(focusRequester),
                    trailingIcon = {
                        if (showEndIcon) {
                            endIcon(
                                drawableResource = mProperties.endIcon
                                    ?: Res.drawable.ic24_mel_exit_circle,
                                inputFieldState = inputFieldState
                            )
                        }

                    },
                    isError = error,
                    keyboardOptions = keyboardOptions,
                    colors = properties?.colors ?: setOutlinedTextFieldDefaults(),
                    shape = properties?.shape ?: setOutlineTextFieldDefaultShape(),
                )

                Box(
                    modifier = Modifier.heightIn(min = supportArea()).fillMaxWidth()
                ){

                }
            }
        }

        @Composable
        override fun Filled(properties: InputFieldProperties?) {
            val mProperties = properties ?: InputFieldProperties()

            Column(
                modifier = (areaModifier ?: Modifier).width(IntrinsicSize.Min)
            ) {
                TextField(
                    value = inputString,
                    onValueChange = { change ->
                        inputFieldState.changeValue(change)
                    },
                    label = mProperties.label,
                    modifier = (properties?.modifier ?: Modifier)
                        .keyListener(Key.Tab) {
                            form.form.moveToNextFocus(index)
                        }.focusRequester(focusRequester),
                    trailingIcon = {
                        if (showEndIcon) {
                            endIcon(
                                drawableResource = mProperties.endIcon
                                    ?: Res.drawable.ic24_mel_exit_circle,
                                inputFieldState = inputFieldState
                            )
                        }
                    },
                    isError = error,
                    keyboardOptions = keyboardOptions,
                    colors = properties?.colors ?: setFiledTextFieldDefaults(),
                    shape = properties?.shape ?: setFilledTextFieldDefaultShape()
                )

                Box(
                    modifier = Modifier.heightIn(min = supportArea()).fillMaxWidth()
                ){

                }
            }
        }
    }
    return style
}

private fun validateUserInput(
    type: Type,
    inputString: String,
    mMessage: FullNameMessage?,
    error: (Boolean) -> Unit,
    showSupportingText: (Boolean) -> Unit,
    message: (String) -> Unit,
    validate: (Boolean) -> Unit
) {
    val double = Regex("^[А-Я][а-я]*(?:-[А-Я][а-я]*)?-?$")
    val apostrophe = Regex("^[А-Я]*['`][А-Я][а-я]*$")
    val simple = Regex("^[А-Я][а-я]*$")

    if (type == Type.Patronymic) {

        val mHelp = "Введите отчество"

        when {
            simple.matches(inputString) -> {
                val valid = inputString.length >= 2
                validate.invoke(valid)
                if (valid) {
                    error.invoke(false)
                    showSupportingText.invoke(false)
                } else {
                    error.invoke(false)
                    showSupportingText.invoke(true)
                    message.invoke(mMessage?.help ?: mHelp)
                }

            }

            else -> {
                val invalidSymbols =
                    inputString.filterNot { Regex("[А-Яа-я]").matches(it.toString()) }
                        .toCharArray().joinToString()
                if (inputString.isNotEmpty()) {
                    error.invoke(true)
                    showSupportingText.invoke(true)
                    message.invoke("Недомустимый символ: $invalidSymbols")
                }
                validate.invoke(false)
            }
        }

    } else {
        val mHelp = if (type == Type.Name) "Введите имя" else "Введите фамилию"
        val mShort = if (type == Type.Name) "Короткое имя" else "Короткая фамилия"

        when {
            simple.matches(inputString) -> {
                val valid = inputString.length >= 2
                validate.invoke(valid)
                if (valid) {
                    error.invoke(false)
                    showSupportingText.invoke(false)
                } else {
                    error.invoke(false)
                    showSupportingText.invoke(true)
                    message.invoke(mMessage?.help ?: mHelp)
                }
            }

            double.matches(inputString) -> {

                val parts = inputString.split("-")
                val allPartsValid =
                    parts.all { it.length >= 2 }
                if (!allPartsValid) {
                    validate.invoke(false)
                    error.invoke(false)
                    showSupportingText.invoke(true)
                    message.invoke(mMessage?.short ?: mShort) // короткий текст
                } else {
                    validate.invoke(true)
                    error.invoke(false)
                    showSupportingText.invoke(false)
                }
            }

            apostrophe.matches(inputString) -> {
                val afterApostrophe = inputString.substringAfter("'").length
                if (afterApostrophe < 2) {
                    validate.invoke(false)
                    error.invoke(false)
                    showSupportingText.invoke(true)
                    message.invoke(mMessage?.short ?: mShort) // короткий текст
                } else {
                    validate.invoke(true)
                    error.invoke(false)
                    showSupportingText.invoke(false)
                }
            }

            else -> {
                val invalidSymbols =
                    inputString.filterNot { Regex("[А-Яа-я]").matches(it.toString()) }
                        .toCharArray().joinToString()
                if (inputString.isNotEmpty()) {
                    error.invoke(true)
                    showSupportingText.invoke(true)
                    message.invoke("Недомустимый символ: $invalidSymbols") //недопустимый символ
                }
                validate.invoke(false)
            }
        }
    }
}

enum class Type {
    Name,
    Surname,
    Patronymic
}

class FullNameMessage(
    val help: String? = null,
    val short: String? = null,
    val required: String? = null
)